import { render, staticRenderFns } from "./ConfirmacaoBotoes.vue?vue&type=template&id=cbfbfa78&"
import script from "./ConfirmacaoBotoes.vue?vue&type=script&lang=js&"
export * from "./ConfirmacaoBotoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports